export default {
    hideForever: (value: boolean) => {
        if(value)
            window.localStorage.setItem('driverAppBanner.dontShowAgain', `true`)
        else
            window.localStorage.removeItem('driverAppBanner.dontShowAgain')
    },
    showNextWeek: () => {
        if(window.localStorage.getItem('driverAppBanner.dontShowAgain'))
            return;

        const today = new Date();
        const day = today.getDay();

        let daysUntilMonday = (8 - day) % 7;
        if (daysUntilMonday === 0) {
            daysUntilMonday = 7;
        }

        today.setDate(today.getDate() + daysUntilMonday);
        today.setHours(0, 0, 0, 0);

        window.localStorage.setItem("driverAppBanner.showDriverAppBanner", today.toISOString())
    },
    shouldShowToday: () => {
        const hideForever = localStorage.getItem("driverAppBanner.dontShowAgain") === "true";
        if (hideForever) 
            return false;

        const nextShow = localStorage.getItem("driverAppBanner.showDriverAppBanner");
        if (!nextShow) 
            return true;

        return new Date() >= new Date(nextShow);
    },
};